import React, { useEffect } from 'react'

import Aos from 'aos'
import 'aos/dist/aos.css'
import { Link } from 'react-router-dom'

export default function Contact() {
    useEffect(() => {
        Aos.init({
            duration: 1000
        })
    }, [])
    
    return (
        <>
             <div className="container-fluid bg-breadcrumb">
                <div className="container text-center py-5" style={{ maxWidth: '900px' }}>
                    <h4 className="text-white display-4 mb-4 wow fadeInDown" data-wow-delay="0.1s">Contact Us</h4>
                    <ol className="breadcrumb d-flex justify-content-center mb-0 wow fadeInDown" data-wow-delay="0.3s">
                        <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                        <li className="breadcrumb-item"><Link to="">Pages</Link></li>
                        <li className="breadcrumb-item active text-primary">Contact</li>
                    </ol>    
                </div>
            </div>


<div className="container-fluid contact py-5">
    <div className="container-fluid py-5">
        {/* Enhanced Header */}
        <div className="text-center mx-auto pb-5" data-aos="fade-up" data-aos-delay="100">
            <h6 className="text-primary text-uppercase fw-bold mb-2">Get In Touch</h6>
            <h1 className="display-4 fw-bold mb-3">Contact <span className="text-primary">Outlook Digital</span></h1>
          
        </div>

        <div className="row g-5">
            {/* First Column - Contact Information */}
            <div className="col-xl-5" data-aos="fade-right" data-aos-delay="200">
                <div className="row g-4">
                    {/* Address */}
                    <div className="col-6 col-sm-6">
                        <div className="contact-add-item p-4 h-100">
                            <div className="contact-icon mb-4">
                                <i className="fas fa-map-marker-alt fa-2x"></i>
                            </div>
                            <div>
                                <h4>Our Address</h4>
                                <p className="mb-0">
                                    July 23 above Al-Tawhid, Al-Nour,<br />
                                    Seventh Floor - Bani Suef
                                </p>
                            </div>
                            <div className="mt-3">
                                <small className="text-primary">
                                    <i className="fas fa-clock me-1"></i> Open: Sun-Thu 9AM-5PM
                                </small>
                            </div>
                        </div>
                    </div>

                    {/* Email */}
                    <div className="col-6 col-sm-6" data-aos="fade-right" data-aos-delay="300">
                        <div className="contact-add-item p-4 h-100">
                            <div className="contact-icon mb-4">
                                <i className="fas fa-envelope fa-2x"></i>
                            </div>
                            <div>
                                <h4>Email Us</h4>
                                <p className="mb-0">
                                    <a  className="text-light text-decoration-none">
                                        sales@outlookds.com
                                    </a>
                                </p>
                            </div>
                            <div className="mt-3">
                                <small className="text-primary">
                                    <i className="fas fa-reply me-1"></i> Response within 24 hours
                                </small>
                            </div>
                        </div>
                    </div>

                    {/* Phone */}
                    <div className="col-6 col-sm-6" data-aos="fade-right" data-aos-delay="400">
                        <div className="contact-add-item p-4 h-100">
                            <div className="contact-icon mb-4">
                                <i className="fas fa-phone-alt fa-2x"></i>
                            </div>
                            <div>
                                <h4>Call Us</h4>
                                <p className="mb-0">
                                    <a href="tel:01205450008" className="text-light text-decoration-none">
                                        01205450008
                                    </a>
                                </p>
                            </div>
                            <div className="mt-3">
                                <small className="text-primary">
                                    <i className="fas fa-headset me-1"></i> Professional support
                                </small>
                            </div>
                        </div>
                    </div>

                    {/* Website */}
                    <div className="col-6 col-sm-6 " data-aos="fade-right" data-aos-delay="500">
                        <div className="contact-add-item p-4 h-100">
                            <div className="contact-icon mb-4">
                                <i className="fas fa-globe fa-2x"></i>
                            </div>
                            <div>
                                <h4>Visit Us</h4>
                                <p className="mb-0">
                                    <a href="https://www.outlookds.com" 
                                       className="text-light text-decoration-none"
                                       target="_blank" 
                                       rel="noopener noreferrer">
                                        www.outlookds.com
                                    </a>
                                </p>
                            </div>
                            <div className="mt-3">
                                <small className="text-primary">
                                    <i className="fas fa-external-link-alt me-1"></i> Explore our services
                                </small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Second Column - Contact Form */}
            <div className="col-xl-7" data-aos="fade-left" data-aos-delay="200">
                <div className="contact-form-container h-100">
                    <h4>Send Us a Message</h4>
                    <form>
                        <div className="row g-4">
                            {/* Name & Email */}
                            <div className="col-md-6">
                                <div className="form-floating">
                                    <input 
                                        type="text" 
                                        className="form-control" 
                                        id="name" 
                                        placeholder="Your Full Name" 
                                        required 
                                    />
                                    <label htmlFor="name">
                                        <i className="fas fa-user me-2"></i>Your Full Name
                                    </label>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-floating">
                                    <input 
                                        type="email" 
                                        className="form-control" 
                                        id="email" 
                                        placeholder="your.email@example.com" 
                                        required 
                                    />
                                    <label htmlFor="email">
                                        <i className="fas fa-envelope me-2"></i>Your Email Address
                                    </label>
                                </div>
                            </div>

                            {/* Phone & Project Type */}
                            <div className="col-md-6">
                                <div className="form-floating">
                                    <input 
                                        type="tel" 
                                        className="form-control" 
                                        id="phone" 
                                        placeholder="+20 123 456 7890" 
                                    />
                                    <label htmlFor="phone">
                                        <i className="fas fa-phone me-2"></i>Your Phone Number
                                    </label>
                                </div>
                            </div>
                   

                    
                            {/* Message */}
                            <div className="col-12">
                                <div className="form-floating">
                                    <textarea 
                                        className="form-control" 
                                        placeholder="Tell us about your project requirements..." 
                                        id="message" 
                                        style={{ height: '150px' }}
                                        required
                                    ></textarea>
                                    <label htmlFor="message">
                                        <i className="fas fa-comment me-2"></i>Your Message
                                    </label>
                                </div>
                            </div>

                            {/* Submit Button */}
                            <div className="col-12 text-center">
                                <button className="btn btn-contact-submit w-100 py-3 text-light" type="">
                                    <i className="fas fa-paper-plane me-2 text-light"></i>Send Message
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>

            {/* Full Width Map */}
            <div className="col-12" data-aos="fade-up" data-aos-delay="300">
                <div className="map-container">
                    <iframe
                        className="w-100"
                        style={{ height: '450px', border: 'none' }}
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d387191.33750346623!2d-73.97968099999999!3d40.6974881!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c24fa5d33f083b%3A0xc80b8f06e177fe62!2sNew%20York%2C%20NY%2C%20USA!5e0!3m2!1sen!2sbd!4v1694259649153!5m2!1sen!2sbd"
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                        title="Outlook Digital Solutions Location"
                        allowFullScreen
                    ></iframe>
                </div>
            </div>
        </div>
    </div>
</div>
   
        </>
    )
}